import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AuthGuard,
  LoginImpersonateContainerComponent,
  LogoutContainerComponent,
  UnauthGuard,
} from '@motivforce/mx-library-angular';

import { LoginRedirectContainerComponent } from './components/login-redirect-container/login-redirect-container.component';
import { NotAllowedContainerComponent } from './components/not-allowed-container/not-allowed-container.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    data: { pageTitleKey: 'Login' },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    pathMatch: 'full',
  },
  {
    path: 'login/admin',
    data: { pageTitleKey: 'Login' },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [UnauthGuard],
  },
  {
    path: 'not-allowed',
    data: { pageTitleKey: 'Access Denied' },
    component: NotAllowedContainerComponent,
    canActivate: [UnauthGuard],
  },
  {
    path: 'logout',
    component: LogoutContainerComponent,
    canActivate: [AuthGuard],
    data: {
      hideHeaderFooter: true,
    },
  },
  {
    path: 'forgot-password',
    data: { pageTitleKey: 'Forgot Password' },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [UnauthGuard],
  },
  {
    path: 'set-password',
    data: { pageTitleKey: 'Set Password' },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [UnauthGuard],
  },
  {
    path: 'redirect',
    component: LoginRedirectContainerComponent,
    canActivate: [],
    data: {
      hideHeaderFooter: true,
    },
  },
  {
    path: 'impersonate',
    component: LoginImpersonateContainerComponent,
    canActivate: [AuthGuard],
    data: {
      hideHeaderFooter: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
